import React, { useEffect, useRef } from 'react';
import './VideoShowcase.css';

const VIDEO_URL = 'https://d3h5y5lv9ri89u.cloudfront.net/landing/website+video.mp4';

const VideoShowcase = () => {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        // React doesn't reliably set the `muted` DOM property, and iOS
        // (Safari + Chrome) requires it to be true to allow autoplay.
        video.muted = true;

        // Attempt autoplay; iOS may still reject (e.g. Low Power Mode),
        // in which case the tap-to-play fallback below takes over.
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(() => {});
        }
    }, []);

    const handleTap = () => {
        const video = videoRef.current;
        if (!video) return;
        video.muted = true;
        if (video.paused) {
            const attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') {
                attempt.catch(() => {});
            }
        }
    };

    return (
        <div className="video-showcase">
            <video
                ref={videoRef}
                className="video-showcase__video"
                src={VIDEO_URL}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                disablePictureInPicture
                onClick={handleTap}
                aria-hidden="true"
                tabIndex={-1}
            />
        </div>
    );
};

export default VideoShowcase;
